export default __webpack_public_path__ + "static/media/onboard.11e71b81.png";